import { useEffect, useState } from "react";
import { Link } from "@tanstack/react-router";
import { Cookie, X } from "lucide-react";

const STORAGE_KEY = "rne-cookie-consent";

export function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return;
    try {
      const saved = window.localStorage.getItem(STORAGE_KEY);
      if (!saved) {
        const t = window.setTimeout(() => setVisible(true), 600);
        return () => window.clearTimeout(t);
      }
    } catch {
      setVisible(true);
    }
  }, []);

  const persist = (value: "accepted" | "rejected") => {
    try {
      window.localStorage.setItem(STORAGE_KEY, value);
    } catch {
      /* ignore */
    }
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      role="dialog"
      aria-live="polite"
      aria-label="Aviso de cookies"
      className="fixed left-1/2 -translate-x-1/2 bottom-3 sm:bottom-5 z-[60] w-[calc(100%-1.5rem)] max-w-[360px] rounded-xl border border-white/10 bg-[#06122B]/95 backdrop-blur-xl text-white shadow-[0_20px_50px_-20px_rgba(6,18,43,0.7)] animate-fade-in"
    >
      <div className="p-3.5">
        <div className="flex items-start gap-2.5">
          <Cookie className="h-4 w-4 text-brand-light shrink-0 mt-0.5" />
          <p className="flex-1 text-[12px] leading-snug text-white/80">
            Usamos cookies para melhorar sua experiência.{" "}
            <Link to="/privacidade" className="text-brand-light font-semibold hover:underline">
              Saiba mais
            </Link>
            .
          </p>
          <button
            type="button"
            onClick={() => persist("rejected")}
            aria-label="Fechar aviso de cookies"
            className="shrink-0 -mt-1 -mr-1 h-6 w-6 rounded-md text-white/60 hover:text-white hover:bg-white/10 flex items-center justify-center transition-colors"
          >
            <X className="h-3.5 w-3.5" />
          </button>
        </div>

        <div className="mt-3 flex gap-2">
          <button
            type="button"
            onClick={() => persist("accepted")}
            className="flex-1 inline-flex items-center justify-center h-8 px-3 rounded-lg bg-white text-brand-dark font-bold text-[12px] hover:bg-white/90 transition-colors"
          >
            Aceitar
          </button>
          <button
            type="button"
            onClick={() => persist("rejected")}
            className="flex-1 inline-flex items-center justify-center h-8 px-3 rounded-lg border border-white/20 hover:bg-white/10 text-white font-semibold text-[12px] transition-colors"
          >
            Essenciais
          </button>
        </div>
      </div>
    </div>
  );
}
